import React from 'react';
import { X, AlertCircle } from 'lucide-react';
import { Button } from '../ui/Button';

/**
 * ErrorModal Component
 * Модальное окно для отображения ошибок
 */
export const ErrorModal = ({ onClose, title, message }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-xl shadow-2xl w-[446px] p-8">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-7 right-8 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X size={16} />
        </button>

        {/* Content */}
        <div className="flex flex-col items-center text-center space-y-4">
          {/* Icon */}
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <AlertCircle size={32} className="text-red-600" />
          </div>

          {/* Title */}
          <h3 className="text-[#2c2d2e] text-2xl font-medium">
            {title || 'Ошибка'}
          </h3>

          {/* Message */}
          <p className="text-[#2c2d2e] text-[15px] leading-5">
            {message || 'Произошла ошибка. Пожалуйста, попробуйте позже.'}
          </p>

          {/* Button */}
          <Button
            type="button"
            variant="primary"
            onClick={onClose}
            className="w-full mt-4"
          >
            Закрыть
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
